import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider, Box } from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'
import { CartButton } from './CartButton'
import { AccountButton } from './AccountButton'
import { RewardsButton } from './RewardsButton'

/**
 * Lists the main action buttons
 *
 * @param {number} count - Number of items in the users cart
 *
 * @returns {function} React Component
 */
const IconBar = ({ count }) => {
  const isTabletOrLarger = useMediaQuery({ minWidth: 600 })

  return (
    <ThemeProvider>
      <Box alignItems="center" justifyContent="flex-end">
        {isTabletOrLarger && (
          <React.Fragment>
            <RewardsButton />
            <AccountButton />
          </React.Fragment>
        )}
        <CartButton count={count} />
      </Box>
    </ThemeProvider>
  )
}

IconBar.propTypes = {
  count: PropTypes.number,
}

export default IconBar
